// removed by extract-text-webpack-plugin
module.exports = {"lightbox__wrap":"RelativesActionsLightbox__lightbox__wrap___2qAVn","lightbox__title":"RelativesActionsLightbox__lightbox__title___3OSma","lightbox__text":"RelativesActionsLightbox__lightbox__text___TJvcd","lightbox__button":"RelativesActionsLightbox__lightbox__button___3tnBF"};


//////////////////
// WEBPACK FOOTER
// ./src/js/components/Lightbox/RelativesActionsLightbox.scss
// module id = 1365
// module chunks = 1